module.exports = __webpack_public_path__ + "img/q-form-left-pattern.95024487.png";